export default "__VITE_ASSET__3212afa9__"